import React, { useState, useEffect, useCallback } from 'react';
import PageHeader from '../../components/PageHeader';
import AppHeader from '../../components/AppHeader';
import AppSidebar from '../../components/AppSidebar';
import { toast, ToastContainer } from 'react-toastify';
import Pagination from '../../components/Pagination';
import CommonTable from '../../components/CommonTable';
import SystemLogsService from '../../services/SystemLogsService';
import ViewData from '../../modals/ViewData';
import UseDebounce from '../../hooks/UseDebounce';
import { PageLimit } from '../../utils/ConstantUtils';
import { DebounceDelay } from '../../utils/ConstantUtils';


const SystemLogs = () => {
  const [filters, setFilters] = useState({
    type: '',
    actioned_by: '',
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const pageLimit = PageLimit;
  const [itemsPerPage, setPageLimit] = useState(pageLimit);
  const offset = (currentPage - 1) * itemsPerPage;
  const [appliedFilters, setAppliedFilters] = useState({});
  const debouncedSearchTerm = UseDebounce(searchTerm, DebounceDelay || 100);
  const columns = [
    { Header: 'Log ID', accessor: 'id' },
    { Header: 'Actioned By', accessor: 'user.name' },
    { Header: 'Activity', accessor: 'activity' },
    { Header: 'Action Time', accessor: 'createdAt' },
    { Header: 'Type', accessor: 'type' },
    { Header: 'Type ID', accessor: 'type_id' },
    { Header: 'IP Address', accessor: 'ip_address' },
    { Header: 'Log data', accessor: 'data' },
  ];
  const [rows, setRows] = useState([]);
  const [logId, setLogId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showViewModal, setShowViewModal] = useState(false);
  const handleShowViewModal = (id) => {
    setLogId(id);
    setShowViewModal(true);
  };
  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await SystemLogsService.getAllLogs({
         currentPage: currentPage,
          limit: itemsPerPage,
          search: debouncedSearchTerm,
          offset: offset,
          filters: appliedFilters,
      });
      if (response.status === 200 && response.data.success) {
        setRows(response.data.data.systemLogs);
        setTotalPages(response.data.data.totalPages);
      } else {
        console.error('Error in fetching logs data:', response);
        toast.error('Error fetching logs data :', response);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }, [appliedFilters, currentPage, debouncedSearchTerm, itemsPerPage, offset]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleItemsPerPageChange = (e) => {
    setPageLimit(e.target.value);
    setCurrentPage(1);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setAppliedFilters(filters);
  };


  return (
    <>
      <AppSidebar />
      <div className="main-content">
        <AppHeader />
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <PageHeader title="System Logs" />
              <div className="tab-content">
                <div className="tab-pane fade show active" id="contactsListPane" role="tabpanel" aria-labelledby="contactsListTab">
                  <div className="card">
                    <div className="card-header">
                      <div className="row align-items-center">
                        <div className="col">
                          <form>
                            <div className="input-group input-group-flush input-group-merge input-group-reverse">
                              <input
                                className="form-control list-search"
                                type="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={handleSearchChange}
                              />
                              <span className="input-group-text">
                                <i className="fe fe-search" />
                              </span>
                            </div>
                          </form>
                        </div>
                        <div className="col-auto me-n3">
                          <form>
                            <select
                              className="form-select form-select-sm form-control-flush"
                              value={itemsPerPage}
                              onChange={handleItemsPerPageChange}
                            >
                              <option value="20">20 per page</option>
                              <option value="40">40 per page</option>
                              <option value="60">60 per page</option>
                              <option value="100">100 Records</option>
                            </select>
                          </form>
                        </div>
                        <div className="col-auto">
                          <div className="dropdown">
                            <button
                              className="btn btn-sm btn-white"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-bs-auto-close="inside"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="fe fe-sliders me-1" /> Filter <span className="badge bg-primary ms-1 d-none">0</span>
                            </button>
                            <form className="dropdown-menu dropdown-menu-end dropdown-menu-card " style={{ width: '550px' }} onSubmit={handleFilterSubmit}>
                              <div className="card-header">
                                <h4 className="card-header-title">Filters</h4>
                              </div>
                              <div className="card-body">
                                <div className="list-group list-group-flush mt-n4 ">
                                  <div className="list-group-item">
                                    <div className="row">
                                      <div className="col-6">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="type"
                                          value={filters?.type || ''}
                                          onChange={handleFilterChange}
                                          placeholder="Enter Type"
                                        />
                                      </div>
                                      <div className="col-6">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="actioned_by"
                                          value={filters?.actioned_by || ''}
                                          onChange={handleFilterChange}
                                          placeholder="Actioned By"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="card-footer">
                                <button className="btn btn-sm btn-primary" type="submit">Apply</button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Common Table component*/}
                    <CommonTable
                      loading={loading}
                      columns={columns}
                      basePath="system-logs"
                      showCheckboxes={false}
                      showActions={false}
                      rows={rows}
                      handleShowViewModal={(logId) => handleShowViewModal(logId)}
                    />
                    <ToastContainer />

                    {/* Pagination Component */}
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      setCurrentPage={setCurrentPage}
                    />

                    {/* {ViewData Component} */}
                    <ViewData
                      show={showViewModal}
                      onCancel={handleCloseViewModal}
                      rows={rows}
                      showAllLogs={true}
                      logId={logId}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SystemLogs;